import { Box, makeStyles, Step, StepLabel, Stepper } from '@material-ui/core'
import React, { useEffect, useState } from 'react'

const useStyles = makeStyles({
  stepper: {
    padding: 0,
  },
})

type Props<T> = {
  steps: React.ElementType[]
  defaultValues: Partial<T>
  submitText: string
  stepProps?: Record<string, unknown>
  onSubmit: (values: T) => void
  onMerge?: (formState: Partial<T>, values: Partial<T>) => Partial<T>
  onDelete?: () => void
}

export function Wizard<T>({
  steps,
  defaultValues,
  submitText,
  stepProps,
  onSubmit,
  onMerge,
  onDelete,
}: Props<T>): React.ReactElement {
  const classes = useStyles()
  const [activeStep, setActiveStep] = useState(0)
  const [formState, setFormState] = useState<Partial<T>>(defaultValues)

  useEffect(() => {
    setFormState(defaultValues)
  }, [defaultValues])

  const isFirstStep = activeStep === 0
  const isLastStep = activeStep === steps.length - 1
  const ActiveStep = steps[activeStep]

  return (
    <Box>
      <Box mb={2} mx={2}>
        <Stepper className={classes.stepper} activeStep={activeStep}>
          {steps.map((step, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Step key={index}>
              <StepLabel />
            </Step>
          ))}
        </Stepper>
      </Box>

      <ActiveStep
        {...stepProps}
        isFirst={isFirstStep}
        isLast={isLastStep}
        defaultValues={formState}
        submitText={submitText}
        onBack={() => setActiveStep(activeStep - 1)}
        onSubmit={(values: Partial<T>) => {
          const newFormValues = onMerge
            ? onMerge(formState, values)
            : { ...formState, ...values }

          if (isLastStep) {
            onSubmit(newFormValues as T)
            return
          }

          setFormState(newFormValues)
          setActiveStep(activeStep + 1)
        }}
        onDelete={onDelete}
      />
    </Box>
  )
}
